export default "__VITE_ASSET__D0aeOP31__"